module.exports = __webpack_public_path__ + "media/images/fr/build-52c40651450a75918ffc18bc5da291f7.png";